import './index.less';

// style dependencies
import '../../button/style';
